// AUTO-GENERATED by scripts/generate-build-info.js — do not edit by hand.
// Regenerated on every build (and in dev when this script is run).
export const BUILD_INFO = {
  "sha": "unknown",
  "longSha": "unknown",
  "branch": "unknown",
  "builtAt": "2026-09-30T22:36:22.420Z"
};
